export default "__VITE_ASSET__BgjDHJBZ__"